import { HotelLayer } from './HotelLayer';

export default HotelLayer;
